import { createContext, useCallback, useContext, useState } from "react";
import { readPref, writePref } from "./prefs";

/** Two card widths for every gallery grid (46 Spec 3.2), kept per device in `volgo.cardSize`. */
export type CardSize = "normal" | "large";

export function useCardSizeState() {
  const [size, setSize] = useState<CardSize>(() =>
    readPref("volgo.cardSize") === "large" ? "large" : "normal",
  );
  const choose = useCallback((next: CardSize) => {
    writePref("volgo.cardSize", next);
    setSize(next);
  }, []);
  return { size, choose };
}

export const CardSizeContext = createContext<ReturnType<typeof useCardSizeState>>({
  size: "normal",
  choose: () => {},
});

export const useCardSize = () => useContext(CardSizeContext);
